import React from 'react';
import { MarqueeRect } from '../hooks/useMarqueeSelection';

const MarqueeOverlay: React.FC<{ rect: MarqueeRect }> = ({ rect }) => (
  <div
    style={{
      position: 'absolute',
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
      background: 'rgba(49, 130, 206, 0.1)',
      border: '1px solid #3182ce',
      borderRadius: 3,
      pointerEvents: 'none',
      zIndex: 10,
    }}
  />
);

export default MarqueeOverlay;
